import { render, staticRenderFns } from "./QuestionMarkIcon.vue?vue&type=template&id=22d74673&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d74673')) {
      api.createRecord('22d74673', component.options)
    } else {
      api.reload('22d74673', component.options)
    }
    module.hot.accept("./QuestionMarkIcon.vue?vue&type=template&id=22d74673&", function () {
      api.rerender('22d74673', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/QuestionMarkIcon.vue"
export default component.exports